import { render, staticRenderFns } from "./ListRegiContent.vue?vue&type=template&id=00da63f0"
import script from "./ListRegiContent.vue?vue&type=script&lang=js"
export * from "./ListRegiContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports